export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a06a0051a62afcd06b92feeb0f321bd2.jpg"
          alt="Modern Construction Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo Insignia */}
        <div className="mb-8 flex justify-center">
          <div className="w-40 h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 flex items-center justify-center">
            <img 
              src="https://static.readdy.ai/image/b449e92a87efa96149f112abe38ee1bc/4647924add033c8d11693d73219fb188.jpeg" 
              alt="MARIN Logo" 
              className="w-full h-full object-contain drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Company Name */}
        <div className="mb-6">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-3 tracking-tight">
            MARIN
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-amber-400 tracking-wide">
            Construesfuerzo S.L.
          </p>
        </div>

        {/* Tagline */}
        <p className="text-lg md:text-xl lg:text-2xl text-white/90 mb-4 max-w-3xl mx-auto leading-relaxed font-light">
          Construcción General en Lanzarote
        </p>
        <p className="text-base md:text-lg text-white/80 mb-12 max-w-2xl mx-auto">
          Transformamos espacios con calidad, profesionalismo y compromiso. Más de una década de experiencia en reformas integrales y construcción.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="mailto:m.construesfuerzo@gmail.com?subject=Solicitud de Presupuesto&body=Hola, me gustaría solicitar un presupuesto para:" className="inline-block bg-amber-500 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-amber-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            Solicitar Presupuesto
          </a>
          <button 
            onClick={() => scrollToSection('proyectos')}
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Ver Proyectos
          </button>
        </div>

        {/* Features */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Calidad Garantizada</h3>
            <p className="text-sm text-white/80">Materiales premium y acabados impecables</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-team-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Equipo Profesional</h3>
            <p className="text-sm text-white/80">Expertos certificados en cada área</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="w-14 h-14 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">Puntualidad</h3>
            <p className="text-sm text-white/80">Cumplimos plazos sin comprometer calidad</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('servicios')}
          className="text-white/80 hover:text-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}